import {useState, useEffect} from "react";
import {
  ApiResponseFromCMS,
  IMoleculeWithCitation,
  ITehnologiesDataFromServer,
} from "../pages/Dashboard/Dashboard.type";

const useFetchDataTechTehnologyById = (
  apiUrl: string,
  apiKey: string,
  tehnologieId: string
) => {
  const [tehnologieData, setTehnologieData] =
    useState<ApiResponseFromCMS<ITehnologiesDataFromServer> | null>(null);
  const [citationList, setCitationList] = useState<ApiResponseFromCMS<
    IMoleculeWithCitation[]
  > | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!tehnologieId) return;

    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const tehnologieUrl = new URL(`${apiUrl}/tehnologies/${tehnologieId}`);
    tehnologieUrl.searchParams.set("populate", "*");

    const citation = new URL(`${apiUrl}/molecules`);
    citation.searchParams.append(
      "populate[clusters][populate][cluster][fields][0]",
      "documentId"
    );
    citation.searchParams.append(
      "populate[clusters][populate][technologies][populate][technology][fields][0]",
      "name"
    );

    Promise.all([
      fetch(tehnologieUrl.href, {method: "GET", headers}).then((response) =>
        response.json()
      ),
      fetch(citation.href, {method: "GET", headers}).then((response) =>
        response.json()
      ),
    ])
      .then(([tehnologieDataResponse, caseListResponse]) => {
        setTehnologieData(tehnologieDataResponse);
        setCitationList(caseListResponse);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrl, apiKey, tehnologieId]);

  return {tehnologieData, citationList, error};
};

export default useFetchDataTechTehnologyById;
